import { connect } from 'react-redux';
import { useRouteMatch } from 'react-router-dom';
import SearchResults from '../../components/headoffice/searchResults';
import { closeSearch } from '../../actions/headOfficeViewActions';
import EmptyView from '../../components/emptyview/emptyView';
import { ROUTES } from '../../constants';
import useColumnPreferences from '../../hooks/useColumnPreferences';

const mapStateToProps = (state) => ({
  keyword: state.projectSearch.keyword,
  rows: state.projectSearch.rows,
  columns: state.projectViewer.tableColumns,
  isLoading: state.projectSearch.isLoading,
});

const mapDispatchToProps = (dispatch) => ({
  onCloseSearch: () => dispatch(closeSearch()),
});

const ProjectSearchResultsContainer = ({
  keyword,
  rows,
  columns,
  onCloseSearch,
  isLoading,
}) => {
  const { columnPreferences } = useColumnPreferences();
  const match = useRouteMatch(`${ROUTES.SPHERE}${ROUTES.PROJECTS}/:projectId`);

  if (isLoading) return <EmptyView isLoading />;
  return (
    <SearchResults
      columns={columns}
      keyword={keyword}
      hcpList={rows || []}
      onCloseSearch={onCloseSearch}
      columnVisibilityModel={
        columnPreferences[match?.params?.projectId]?.visibility
      }
      columnOrderModel={columnPreferences[match?.params?.projectId]?.order}
    />
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProjectSearchResultsContainer);
